import type { User } from '@/types/api';

export function hasSubscriptionFeature(user: User | null, feature: string, minValue: unknown = true): boolean {
  if (user?.active_restaurant?.trial_ends_at) {
    const trialEndDate = new Date(user.active_restaurant.trial_ends_at);
    const now = new Date();
    if (trialEndDate > now) {
      return true; // Trial users have access to all features
    }
  }

  const features = user?.active_restaurant?.subscription?.plan?.features;
  if (!features || !(feature in features)) return false;
  const value = features[feature];
  if (typeof minValue === 'boolean') return !!value === minValue;
  if (typeof minValue === 'number') return typeof value === 'number' && value >= minValue;
  return value === minValue;
}
